import React, {useCallback} from "react";
import {
    Box,
    Button,
    Checkbox,
    CircularProgress,
    FormControlLabel,
    FormGroup,
    IconButton,
    Popover, Tooltip,
    Typography
} from "@mui/material";
import * as turf from "@turf/turf";
import Map, {Layer, Marker, Popup, Source} from 'react-map-gl';
import ApartmentIcon from '@mui/icons-material/Apartment';

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import DpeCtrl from "../../svc/openapi/DpeCtrl";
import RightAccordion, {computeSurfUtile, getTypeEq} from "../../component/RightAccordion";
import DpeScale from "../../component/DpeScale";
import StoreIcon from "@mui/icons-material/Store";
import OtherScale from "../../component/OtherScale";
import {CSVLink} from "react-csv";
import IconExcel from "../../ico/IconExcel";
import BdnbCtrl from "../../svc/openapi/BdnbCtrl";
import KpiView from "../compos/KpiView";
import html2canvas from "html2canvas";
import RncCtrl from "../../svc/openapi/RncCtrl";
import {getAddresse2} from "../../component/v2/HeaderDetails";

const MAPBOX_TOKEN = 'pk.eyJ1IjoiYmxhbmdlNDgiLCJhIjoiY2xkMWhrcjBzMDB1aDNzbGVsdGR5cGU1aSJ9.xcs1ihAFqlazzqNrXNiobQ';


export function getDpeColor(dpe) {
    if (dpe === "A") {
        return "#2d682e";
    } else if (dpe === "B") {
        return "#43ce3f";
    } else if (dpe === "C") {
        return "#cefc43";
    } else if (dpe === "D") {
        return "#f7f72b";
    } else if (dpe === "E") {
        return "#f6c824";
    } else if (dpe === "F") {
        return "#f79b40";
    } else if (dpe === "G") {
        return "#f71e1a";
    } else {
        return "#808080";
    }
}

export function computeSurface(batiments, annee_construction) {
    let r = 0;
    let insertedBatiments = {};
    batiments.forEach(batiment => {
        if (!insertedBatiments[[batiment["batiment_construction_id"]]]) {
            r += computeSurfUtile(batiment["hauteur"], batiment["s_geom_cstr"], annee_construction);
            insertedBatiments[[batiment["batiment_construction_id"]]] = true;
        }
    })
    return r;
}

export async function exportImage(printRef, fileName) {
    const canvas = await html2canvas(printRef.current);
    const data = canvas.toDataURL('image/jpg');
    const link = document.createElement('a');


    if (typeof link.download === 'string') {
        link.href = data;
        link.download = fileName + ".jpg";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    } else {
        window.open(data);
    }

}

export function getMaxDpe(listOfDpesV1) {
    let v = 0;
    let dpe = "N"
    Object.keys(listOfDpesV1).forEach(dpeV1 => {
        if (listOfDpesV1[dpeV1] >= v) {
            v = listOfDpesV1[dpeV1];
            dpe = dpeV1;
        }
    })
    return dpe;
}

export function getMaxDpeValue(listOfDpes, dpeType = "etiquette_dpe") {
    let r = {A: 0, B: 0, C: 0, D: 0, E: 0, F: 0, G: 0, N: 0};
    listOfDpes.forEach(dpe => {
        r[dpe[dpeType]] += 1
    })
    return getMaxDpe(r);
}

export default function MapPage({codeIris}) {
    const [anchorEl, setAnchorEl] = React.useState(null);


    const open = Boolean(anchorEl);


    const [viewState, setViewState] = React.useState({
        longitude: 3.731902,
        latitude: 43.791864,
        zoom: 1
    });
    const [selectedItem, setSelectedItem] = React.useState(undefined);


    const [dpev1, setDpev1] = React.useState(false);


    const [loading, setLoading] = React.useState(true);

    const [typeBat, setTypeBat] = React.useState(undefined);
    const [propCopro, setPropCopro] = React.useState(undefined);
    const [surface, setSurface] = React.useState(undefined);

    const [filters, setFilters] = React.useState({
        dpe: {A: true, B: true, C: true, D: true, E: true, F: true, G: true, N: true},
        dpeT: {A: true, B: true, C: true, D: true, E: true, F: true, G: true, N: true},
        ges: {A: true, B: true, C: true, D: true, E: true, F: true, G: true, N: true},
        surf: {A: true, B: true, C: true, D: true, E: true, F: true, G: true, N: true},
        date: {A: true, B: true, C: true, D: true, E: true, F: true, G: true, N: true},
        typeSelBat: {A: true, B: true, C: true, D: true, E: true, F: true, G: true, N: true},
        propCopro: {A: true, B: true}
    });

    const [listOfBans, setListOfBans] = React.useState(undefined);

    const [cst, setcst] = React.useState(0);

    const [dpe, setDpe] = React.useState(undefined);


    const [widthOfRigth, setWidthOfRigth] = React.useState(false);
    const [widthOfLeft, setWidthOfLeft] = React.useState(true);


    const [dpeIris, setDpeiris] = React.useState({});


    const [irisGeoms, setIrisGeom] = React.useState(undefined);

    const headers = [
        {label: "Ville", key: "ban_city"},
        {label: "Type de voie", key: "type_voie"},
        {label: "Num de la voie", key: "ban_number"},
        {label: "Nom de la voie", key: "ban_street"},
        {label: "Latitude", key: "lat"},
        {label: "Longitude", key: "long"},
        {label: "Année de construction", key: "annee_construction"},
        {label: "Surface utile", key: "surfaceUtile"},
        {label: "Usage primaire", key: "usage_niveau_1_txt"},
        {label: "Usage secondaire", key: "l_usage_2"},
        {label: "DPE", key: "dpe"},
        {label: "Copropriété", key: "copro"},
        {label: "Nom copropriété", key: "l_nom_copro"},
        {label: "Société/collectivité", key: "soc"},
        {label: "Nom propriétaire", key: "prop"},
        {label: "Siren", key: "siren"},
        {label: "Forme juridique", key: "forme_juridique"}

    ];
    const [csv, setCsv] = React.useState([])


    function getYear(annee_construction) {
        if (annee_construction === null || annee_construction === "" || annee_construction === 0) {
            return "N"
        } else if (Number(annee_construction) < 1949) {
            return "A";
        } else if (Number(annee_construction) < 1960) {
            return "B";
        } else if (Number(annee_construction) < 1975) {
            return "C";
        } else if (Number(annee_construction) < 1994) {
            return "D";
        } else if (Number(annee_construction) < 2001) {
            return "E";
        } else if (Number(annee_construction) < 2011) {
            return "F";
        } else {
            return "G";
        }
    }


    function getTypeUsage(usage_niveau_1_txt) {
        if (usage_niveau_1_txt === "Secondaire") {
            return "A";
        } else if (usage_niveau_1_txt === "Dépendance") {
            return "B";
        } else if (usage_niveau_1_txt === "Tertiaire & Autres") {
            return "C";
        } else if (usage_niveau_1_txt === "Résidentiel collectif") {
            return "D";
        } else if (usage_niveau_1_txt === "Résidentiel individuel") {
            return "E";
        } else {
            return "N";
        }
    }

    function getCopro(l_nom_copro) {
        if (!l_nom_copro) {
            return "A";
        } else if (l_nom_copro && l_nom_copro !== "") {
            return "A";
        } else {
            return "B";
        }
    }

    function getProp(nb_proprietaires) {

        if (nb_proprietaires > 0) {
            return "A";
        }
        return "B";
    }

    function getSurface(surface) {
        if (!surface || surface === 0 || surface === null || surface === "0") {
            return "N";
        } else if (surface < 250) {
            return "A";
        } else if (surface < 501) {
            return "B";
        } else if (surface < 1001) {
            return "C";
        } else if (surface < 1501) {
            return "D";
        } else if (surface < 2001) {
            return "E";
        } else if (surface < 2500) {
            return "F";
        } else {
            return "G";
        }

    }


    React.useEffect(() => {
        if (filters && listOfBans) {
            let csv = []
            Object.keys(listOfBans).forEach(key => {
                let e = listOfBans[key];
                let visible = true;
                if (!e?.coord?.lat || !e?.coord?.long) {
                    visible = false;
                }
                if (!filters.propCopro[e.stats.prop]) {
                    visible = false;
                }
                if (!filters.surf[e.stats.surface]) {
                    visible = false;
                }
                if (!filters.typeSelBat[e.stats.batiment]) {
                    visible = false;
                }
                if (!filters.date[e.stats.periode]) {
                    visible = false;
                }
                if (visible) {
                    let names = []
                    let formes_juridiques = []
                    Object.keys(e.props).forEach(siren => {
                        let prop = e.props[siren];
                        names.push(prop.denomination)
                        formes_juridiques.push(prop.forme_juridique)
                    })
                    csv.push({
                        "ban_city": e.cle_interop_adr,
                        "type_voie": e.meta.type_voie,
                        "ban_street": e.meta.nom_voie,
                        "ban_number": e.meta.numero,
                        "lat": e.coord.lat,
                        "long": e.coord.long,
                        "annee_construction": e.meta.annee_construction,
                        "surfaceUtile": e.meta.surface,
                        "usage_niveau_1_txt": getTypeEq(e.meta.usage_niveau_1_txt),
                        "l_usage_2": getTypeEq(e.meta.l_usage_2),
                        "copro": e.meta.l_nom_copro !== "" ? "Oui" : "Non",
                        "soc": Number(e.meta.nb_proprietaires) > 0 ? "Oui" : "Non",
                        "prop": names.join(", "),
                        "l_nom_copro": e.meta.l_nom_copro ? e.meta.l_nom_copro.replaceAll("{", "").replaceAll("}", "").replaceAll('"', "") : "N/A",
                        "siren": Object.keys(e.props).join(", "),
                        "forme_juridique": formes_juridiques.join(", "),
                        "dpe": e.stats.dpeV2 !== "N" ? e.stats.dpeV2 : (e.stats.dpeV1 !== "N" ? e.stats.dpeV1 : "N")
                    })
                }
            });
            setCsv(csv)
        }
    }, [filters, listOfBans]);


    function initEmpty(bans, ban) {
        if (!bans[ban]) {
            bans[ban] = {
                notes: {
                    batiments: "N",
                    copro: "N",
                    surface: "N",
                    periode: "N",
                    l_usage_2: "N"

                }, values: {
                    batiments: "",
                    copro: "",
                    surface: "",
                    periode: "",
                    l_usage_2: ""
                }

            }
        }
    }

    React.useEffect(() => {
            if (codeIris) {

                DpeCtrl.getShape(codeIris, shape => {
                    setIrisGeom(shape);

                    function initListOfbans(res, cle_interop_adr) {
                        if (!res[cle_interop_adr]) {
                            res[cle_interop_adr] = {
                                coord: null,
                                isPincipal: false,
                                cle_interop_adr_principale_ban: null,
                                cle_interop_adr: cle_interop_adr,
                                batiment_groupe_id: null,
                                group: false,
                                surface: 0,
                                props: {},
                                stats: {
                                    dpeTer: "N",
                                    dpeV1: "N",
                                    dpeV2: "N",
                                    dpeV2I: "N",
                                    surface: "N",
                                    copro: "N",
                                    prop: "N",
                                    batiment: "N",
                                    periode: "N",
                                },
                                batiments: [],
                                meta: null,
                                listOfDpesV1: [],
                                listOfDpesV2: [],
                                listOfDpesV2Immeuble: [],
                                listOfDpesTer: [],
                            }
                        }
                    }


                    function organizeByBans(stats, dpesV2, dpesV2Immeuble, dpesTer) {

                        let props = {}
                        stats?.proprietaires.forEach(prop => {
                            if (!props[prop.cle_interop_adr]) {
                                props[prop.cle_interop_adr] = {}
                            }
                            if (!props[prop.cle_interop_adr][prop.siren]) {
                                props[prop.cle_interop_adr][prop.siren] = prop;
                            }
                        })

                        let listOfBatiments = {};
                        stats?.batiments.forEach(batiment => {
                            if (!listOfBatiments[batiment.batiment_groupe_id]) {
                                listOfBatiments[batiment.batiment_groupe_id] = [];
                            }
                            listOfBatiments[batiment.batiment_groupe_id].push(batiment);

                        })

                        let res = {}
                        stats?.metadonnees.forEach(meta => {
                            initListOfbans(res, meta.cle_interop_adr);
                            if (props[meta.cle_interop_adr]) {
                                res[meta.cle_interop_adr].props = props[meta.cle_interop_adr];
                            }
                            res[meta.cle_interop_adr].meta = meta;
                            res[meta.cle_interop_adr].batiment_groupe_id = meta.batiment_groupe_id;
                            if (meta.geom) {
                                let geoJson = JSON.parse(meta.geom);
                                res[meta.cle_interop_adr].coord = {
                                    lat: geoJson.coordinates[1],
                                    long: geoJson.coordinates[0]
                                }
                            }
                            res[meta.cle_interop_adr].isPincipal = meta.cle_interop_adr_principale_ban === meta.cle_interop_adr || meta.cle_interop_adr_principale_ban === null;
                            res[meta.cle_interop_adr].cle_interop_adr_principale_ban = meta.cle_interop_adr_principale_ban;
                            res[meta.cle_interop_adr].group = Number(meta.nb_adresses) > 1;


                            res[meta.cle_interop_adr].batiments = listOfBatiments[meta.batiment_groupe_id] || [];
                            res[meta.cle_interop_adr].meta.surface = computeSurface(res[meta.cle_interop_adr].batiments, meta.annee_construction);

                            res[meta.cle_interop_adr].stats.periode = getYear(meta.annee_construction);
                            res[meta.cle_interop_adr].stats.batiment = getTypeUsage(meta.usage_niveau_1_txt);
                            res[meta.cle_interop_adr].stats.copro = getCopro(meta.l_nom_copro);
                            res[meta.cle_interop_adr].stats.prop = getProp(meta.nb_proprietaires);
                            res[meta.cle_interop_adr].stats.surface = getSurface(meta.surface);

                        })
                        stats?.listOfDpeV1.forEach(dpes => {
                            initListOfbans(res, dpes.cle_interop_adr);
                            res[dpes.cle_interop_adr].listOfDpesV1.push(dpes);
                            res[dpes.cle_interop_adr].stats.dpeV1 = getMaxDpeValue(res[dpes.cle_interop_adr].listOfDpesV1, "classe_conso_energie_arrete_2012");
                        })

                        Object.keys(dpesV2).forEach(banId => {
                            initListOfbans(res, banId);
                            if (res[banId] && dpesV2[banId]) {
                                res[banId].listOfDpesV2 = dpesV2[banId];
                                let r = {A: 0, B: 0, C: 0, D: 0, E: 0, F: 0, G: 0, N: 0};
                                res[banId].listOfDpesV2.forEach(dpe => {
                                    r[dpe.etiquette_dpe] += 1
                                })
                                res[banId].stats.dpeV2 = getMaxDpeValue(res[banId].listOfDpesV2, "etiquette_dpe");
                            }
                        })
                        //ICI
                        Object.keys(dpesV2Immeuble).forEach(banId => {
                            initListOfbans(res, banId);
                            if (res[banId] && dpesV2Immeuble[banId]) {
                                res[banId].listOfDpesV2Immeuble = dpesV2Immeuble[banId];
                                let r = {A: 0, B: 0, C: 0, D: 0, E: 0, F: 0, G: 0, N: 0};
                                res[banId].listOfDpesV2Immeuble.forEach(dpe => {
                                    r[dpe.etiquette_dpe] += 1
                                })
                                res[banId].stats.dpeV2I = getMaxDpeValue(res[banId].listOfDpesV2Immeuble, "etiquette_dpe");
                            }
                        })

                        Object.keys(dpesTer).forEach(banId => {
                            if (res[banId]) {
                                res[banId].listOfDpesTer = dpesTer[banId];
                                let r = {A: 0, B: 0, C: 0, D: 0, E: 0, F: 0, G: 0, N: 0};
                                res[banId].listOfDpesTer.forEach(dpe => {
                                    r[dpe.etiquette_dpe] += 1
                                })
                                res[banId].stats.dpeTer = getMaxDpeValue(res[banId].listOfDpesTer, "etiquette_dpe");
                            }
                        })
                        return res;
                    }

                    function computeStats(bans) {
                        let rDpes = {
                            "A": 0,
                            "B": 0,
                            "C": 0,
                            "D": 0,
                            "E": 0,
                            "F": 0,
                            "G": 0,

                            "N": 0
                        }
                        let rBatiments = {
                            "A": 0,
                            "B": 0,
                            "C": 0,
                            "D": 0,
                            "E": 0,
                            "N": 0
                        }
                        let rProprietaires = {
                            "A": 0,
                            "B": 0,
                            "N": 0
                        }
                        let rSurface = {
                            "A": 0,
                            "B": 0,
                            "C": 0,
                            "D": 0,
                            "E": 0,
                            "F": 0,
                            "G": 0,
                            "N": 0
                        }
                        let rPeriode = {
                            "A": 0,
                            "B": 0,
                            "C": 0,
                            "D": 0,
                            "E": 0,
                            "F": 0,
                            "G": 0,
                            "N": 0
                        }

                        Object.keys(bans).forEach(key => {
                            const ban = bans[key];
                            rDpes[ban.stats.dpeV2] += 1;
                            rBatiments[ban.stats.batiment] += 1;
                            rProprietaires[ban.stats.prop] += 1;
                            rSurface[ban.stats.surface] += 1;
                            rPeriode[ban.stats.periode] += 1;

                        })

                        let dpeIris = "A"
                        let nb = rDpes[dpeIris];
                        Object.keys(rDpes).forEach(dpeKey => {
                            if (dpeKey == "N") return;
                            if (rDpes[dpeKey] > nb) {
                                nb = rDpes[dpeKey];
                                dpeIris = dpeKey;
                            }
                        })

                        setTypeBat(rBatiments);
                        setPropCopro(rProprietaires);
                        setSurface(rSurface);
                        setcst(rPeriode);
                        setDpe(rDpes)

                        let color = {}
                        color[codeIris] = dpeIris
                        setDpeiris(color);


                    }

                    BdnbCtrl.getIrisStats(codeIris, res => {
                        DpeCtrl.gestListOfDpes(codeIris, resDpes => {
                            let lsitOfDpesV2 = {};
                            let listOfDpesV2Immeuble = {};
                            resDpes.forEach(dpe => {
                                if (!lsitOfDpesV2[dpe.identifiant_ban]) {
                                    lsitOfDpesV2[dpe.identifiant_ban] = [];
                                    listOfDpesV2Immeuble[dpe.identifiant_ban] = [];
                                }
                                if (dpe.methode_application_dpe !== "dpe immeuble collectif") {
                                    let findIndex = lsitOfDpesV2[dpe.identifiant_ban].findIndex(d => d.numero_dpe === dpe.numero_dpe);
                                    if (findIndex > -1) {
                                        return;
                                    }
                                    lsitOfDpesV2[dpe.identifiant_ban].push(dpe);
                                } else {
                                    let findIndex = listOfDpesV2Immeuble[dpe.identifiant_ban].findIndex(d => d.numero_dpe === dpe.numero_dpe);
                                    if (findIndex > -1) {
                                        return;
                                    }
                                    listOfDpesV2Immeuble[dpe.identifiant_ban].push(dpe);
                                }
                            })
                            DpeCtrl.gestListOfDpesTer(codeIris, resTer => {
                                let lsitOfDpesTer = {};
                                resTer.forEach(dpe => {
                                    if (!lsitOfDpesTer[dpe.identifiant_ban]) {
                                        lsitOfDpesTer[dpe.identifiant_ban] = [];
                                    }
                                    let findIndex = lsitOfDpesTer[dpe.identifiant_ban].findIndex(d => d.numero_dpe === dpe.numero_dpe);
                                    if (findIndex > -1) {
                                        return;
                                    }
                                    lsitOfDpesTer[dpe.identifiant_ban].push(dpe);
                                })

                                let bans = organizeByBans(res, lsitOfDpesV2, listOfDpesV2Immeuble, lsitOfDpesTer);
                                computeStats(bans)

                                setListOfBans(bans);
                            })
                        })

                    })
                })
            }

        }, [codeIris]
    );

    React.useEffect(() => {
        if (listOfBans && irisGeoms) {
            setLoading(false)
        }
    }, [listOfBans, irisGeoms])

    const mapRef = React.useCallback(mapR => {
        if (mapR && irisGeoms) {
            let geo = JSON.parse(irisGeoms[codeIris].geojson);

            const bbox = turf.bbox(geo);
            const bboxPolygon = turf.bboxPolygon(bbox);
            const center = turf.center(bboxPolygon);
            setViewState({
                ...viewState,
                latitude: center.geometry.coordinates[0],
                longitude: center.geometry.coordinates[1]
            });
            mapR.fitBounds(bbox, {padding: 20});

        }
    }, [irisGeoms]);


    const [bdnb_details, setBdnb_details] = React.useState(undefined);

    React.useEffect(() => {
        if (selectedItem) {
            setWidthOfRigth(false);

            BdnbCtrl.getSyntheseBdnb(selectedItem.cle_interop_adr, res => {
                res.dpeV2 = []
                res.dpeTer = []
                res.listOfDpesV2Immeuble = []
                listOfBans[selectedItem.cle_interop_adr].listOfDpesV2.forEach(dpes => {
                    res.dpeV2.push(dpes);
                })
                listOfBans[selectedItem.cle_interop_adr].listOfDpesTer.forEach(dpes => {
                    res.dpeTer.push(dpes);
                })
                listOfBans[selectedItem.cle_interop_adr].listOfDpesV2Immeuble.forEach(dpes => {
                    res.listOfDpesV2Immeuble.push(dpes);
                })


                RncCtrl.getRnc(res.metadonnees[0].numero_immat_principal, rncDetails => {
                    res.rnc = rncDetails;
                    setBdnb_details(res)
                })
            });
        } else {
            setWidthOfRigth(false)
            setBdnb_details(undefined);
        }
    }, [selectedItem])

    function getDpeV1() {
        return (<Box sx={{width: "100%", display: "flex", flexDirection: "row"}}>

        </Box>);
    }


    const [overBatimentGroupId, setOverBatimentGroupId] = React.useState(undefined);

    function generateGeoJsonFromBans() {
        let res = {
            "type": "FeatureCollection",

            "features": listOfBans && Object.keys(listOfBans)
                .filter((ban) => {
                    const bdnb = listOfBans[ban];

                    if (!bdnb?.coord?.lat || !bdnb?.coord?.long) {
                        return false;
                    }
                    if (!filters.propCopro[bdnb.stats.prop]) {
                        return false;
                    }
                    if (!filters.surf[bdnb.stats.surface]) {
                        return false;
                    }
                    if (!filters.typeSelBat[bdnb.stats.batiment]) {
                        return false;
                    }
                    if (!filters.date[bdnb.stats.periode]) {
                        return false;
                    }
                    return true;
                })
                .map((ban, index) => {
                    const bdnb = listOfBans[ban];


                    let borderWidth = 2;
                    let containsDpesV2Style = bdnb.listOfDpesV2.length > 0 ? "solid" : "dotted";
                    let valDpe = "N";
                    if (dpev1 && bdnb.stats.dpeV1 !== "N" && filters.dpe[bdnb.stats.dpeV1]) {
                        valDpe = bdnb.stats.dpeV1;
                    }
                    if (bdnb.stats.dpeV2 !== "N" && filters.dpe[bdnb.stats.dpeV2]) {
                        valDpe = bdnb.stats.dpeV2;
                    }
                    let color = getDpeColor(valDpe);

                    let colorBorder = "#000";
                    if (bdnb.batiment_groupe_id === overBatimentGroupId) {
                        colorBorder = "#ff0000";
                        borderWidth = 5;
                        if (bdnb.cle_interop_adr === bdnb.cle_interop_adr_principale_ban) {
                            colorBorder = "#00ff00";
                        }
                    }
                    if (selectedItem && selectedItem.cle_interop_adr === bdnb.cle_interop_adr) {

                        colorBorder = "#ff0000";
                        borderWidth = 5;
                        if (bdnb.cle_interop_adr === bdnb.cle_interop_adr_principale_ban) {
                            colorBorder = "#00ff00";
                        }

                    }
                    let a = getAddresse2(bdnb.meta)
                    return {
                        type: "Feature",
                        properties: {
                            id: ban,
                            circleRadius: 6,
                            circleColor: color,
                            circleStrokeColor: colorBorder,
                            circleStrokeWidth: borderWidth,
                            circleStrokeDasharray: containsDpesV2Style,
                            ban: ban,
                            adresse: a
                        },
                        geometry: {"type": "Point", "coordinates": [bdnb.coord.long, bdnb.coord.lat]},

                    }
                })
        }

        /*
        {
                    "type": "Feature",
                    "properties": {
                        "id": "ak16994521",
                        "mag": 2.3,
                        "time": 1507425650893,
                        "felt": null,
                        "tsunami": 0
                    },
                    "geometry": {"type": "Point", "coordinates": [3.5, 44.51667, 0.0]}
                }
         */
        return res;
    }

    const [hoverInfo, setHoverInfo] = React.useState(null);

//https://github.com/nocturneio/react-dpe-generator/blob/master/src/index.js
    if (loading) {
        return (<Box sx={{
            width: "100vw",
            height: "100vh",
            display: "flex",
            alignItems: "center",
            alignContent: "center",
            justifyContent: "center"
        }}>
            <CircularProgress/>
        </Box>)
    } else {
        return (
            <Box sx={{
                width: "100vw",
                height: "100vh",
                display: "flex",
                alignItems: "center",
                flexDirection: "column"
            }}>
                <Box sx={{
                    backgroundColor: "#ffffff",
                    width: widthOfLeft ? 270 : 45,
                    height: "100vh",
                    zIndex: 99,
                    position: "absolute",
                    top: 0,
                    left: 0,
                    display: "flex"
                }}>
                    <Box sx={{
                        display: "flex",
                        justifyContent: "space-evenly",
                        flexDirection: "column"
                    }}>
                        <Box sx={{
                            height: 45,
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "flex-end"
                        }}>
                            {widthOfLeft && <IconButton onClick={() => {
                                setWidthOfLeft(false);
                            }}>
                                <ArrowBackIosIcon/>
                            </IconButton>}
                            {!widthOfLeft && <IconButton onClick={() => {
                                setWidthOfLeft(true);
                            }}>
                                <ArrowForwardIosIcon/>

                            </IconButton>}

                        </Box>
                        <Box sx={{height: "95vh"}}>
                            {widthOfLeft && <Box
                                sx={{
                                    height: "100%",
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    flexDirection: "column"
                                }}>
                                <Box sx={{marginBottom: 1}}>

                                    <DpeScale
                                        title={"DPE opposables"}
                                        setDpev1={setDpev1}
                                        dpev1={dpev1}

                                        scalecolor={{
                                            "A": "#168018",
                                            "B": "#43ce3f",
                                            "C": "#cefc43",
                                            "D": "#f7f72b",
                                            "E": "#f6c824",
                                            "F": "#f79b40",
                                            "G": "#f71e1a"
                                        }}
                                        text={{
                                            "A": "A",
                                            "B": "B",
                                            "C": "C",
                                            "D": "D",
                                            "E": "E",
                                            "F": "F",
                                            "G": "G"
                                        }}
                                        dpe={dpe}
                                        changeState={(id) => {
                                            setFilters({...filters, dpe: id});

                                        }}
                                        icon={<ApartmentIcon fontSize="small"/>}
                                        iconTer={<StoreIcon fontSize="small"/>}

                                    />
                                </Box>

                                <Box sx={{marginBottom: 1}}>

                                    <OtherScale
                                        title={"Surfaces Utiles"}
                                        size={130}
                                        scalecolor={{
                                            "A": "#DBDBDBFF",
                                            "B": "#DBDBDBFF",
                                            "C": "#DBDBDBFF",
                                            "D": "#DBDBDBFF",
                                            "E": "#DBDBDBFF",
                                            "F": "#DBDBDBFF",
                                            "G": "#DBDBDBFF"
                                        }}
                                        text={{
                                            "A": "<250 m²",
                                            "B": "251 & 500 m²",
                                            "C": "501 & 1000 m²",
                                            "D": "1001 & 1500 m²",
                                            "E": "1501 & 2000 m²",
                                            "F": "2001 & 2500 m²",
                                            "G": ">2501 m²"
                                        }}
                                        dpe={surface}
                                        changeState={(id) => {
                                            setFilters({...filters, surf: id});
                                        }}
                                    />
                                </Box>
                                <Box sx={{marginBottom: 1}}>
                                    <OtherScale
                                        title={"Type de propriétaires"}
                                        size={130}
                                        scalecolor={{
                                            "A": "#DBDBDBFF",
                                            "B": "#DBDBDBFF"
                                        }}
                                        text={{
                                            "A": "Perso. morales",
                                            "B": "Perso. physiques"
                                        }}
                                        dpe={propCopro}
                                        changeState={(id) => {

                                            setFilters({...filters, propCopro: id});
                                        }}
                                    />
                                </Box>
                                <Box sx={{marginBottom: 1}}>
                                    <OtherScale
                                        title={"Type de batiment"}
                                        size={130}
                                        scalecolor={{
                                            "A": "#DBDBDBFF",
                                            "B": "#DBDBDBFF",
                                            "C": "#DBDBDBFF",
                                            "D": "#DBDBDBFF",
                                            "E": "#DBDBDBFF",
                                            "F": "#DBDBDBFF",
                                            "G": "#DBDBDBFF"
                                        }}
                                        text={{
                                            "A": "Secondaire",
                                            "B": "Dépendance",
                                            "C": "Tertiaire & aut.",
                                            "D": "Résidentiel col.",
                                            "E": "Résidentiel ind."
                                        }}
                                        dpe={typeBat}
                                        changeState={(id) => {
                                            setFilters({...filters, typeSelBat: id});
                                        }}
                                    />
                                </Box>
                                <Box sx={{marginBottom: 1}}>

                                    <OtherScale
                                        title={"Périodes de construction"}
                                        scalecolor={{
                                            "A": "#DBDBDBFF",
                                            "B": "#DBDBDBFF",
                                            "C": "#DBDBDBFF",
                                            "D": "#DBDBDBFF",
                                            "E": "#DBDBDBFF",
                                            "F": "#DBDBDBFF",
                                            "G": "#DBDBDBFF"
                                        }}
                                        size={100}
                                        text={{
                                            "A": "< 1949",
                                            "B": "1949 à 1959",
                                            "C": "1960 à 1974",
                                            "D": "1975 à 1993",
                                            "E": "1994 à 2000",
                                            "F": "2001 à 2010",
                                            "G": "> 2011"
                                        }}
                                        dpe={cst}
                                        changeState={(id) => {
                                            setFilters({...filters, date: id});
                                        }}
                                    />
                                </Box>
                                <Box sx={{display: "flex", justifyContent: "center"}}>

                                    <CSVLink data={csv} headers={headers} separator={";"}
                                             filename={`${codeIris}-${new Date().getDay()}_${new Date().getMonth()}_${new Date().getFullYear()}.csv`}>
                                        <Button>
                                            <IconExcel/>
                                            Export Excel
                                        </Button>
                                    </CSVLink>
                                </Box>
                                <Box sx={{height: 50}}/>
                                <Box>
                                    <Typography sx={{width: 200, textAlign: "center", fontWeight: 800}}
                                                variant="subtitle1">Source de données :</Typography>
                                    <ul>
                                        <Typography sx={{width: 200, textAlign: "center", fontWeight: 600}}
                                                    variant="subtitle2"
                                                    component="li">{bdnb_millesime}</Typography>
                                        <Typography sx={{width: 200, textAlign: "center", fontWeight: 600}}
                                                    variant="subtitle2" component="li">ADEME Observatoire
                                            DPE</Typography>
                                    </ul>
                                </Box>
                            </Box>}
                        </Box>
                    </Box>

                </Box>

                <Box sx={{width: "100vw", height: "100vh", display: "flex"}}>
                    <Map
                        ref={mapRef}

                        onMove={evt => setViewState(evt.viewState)}

                        mapStyle="mapbox://styles/mapbox/streets-v9"
                        mapboxAccessToken={MAPBOX_TOKEN}
                        interactiveLayerIds={['data']}
                        onMouseMove={(e) => {
                            const features = e.features;
                            if (features.length > 0) {
                                const bdnb = listOfBans[features[0].properties.ban];

                                if (bdnb.batiment_groupe_id) {
                                    setOverBatimentGroupId(bdnb.batiment_groupe_id)
                                }
                                setHoverInfo({
                                    longitude: e.lngLat.lng,
                                    latitude: e.lngLat.lat,
                                    adresse: features[0].properties.adresse
                                });

                            } else {
                                setHoverInfo(null);
                                setOverBatimentGroupId(undefined)
                            }

                        }}
                        onMouseLeave={(e) => {
                            setHoverInfo(null);
                            setOverBatimentGroupId(undefined)
                        }}
                        onClick={(e) => {
                            const features = e.features;
                            if (features.length > 0) {
                                const bdnb = listOfBans[features[0].properties.ban];
                                setViewState({
                                    ...viewState,
                                    latitude: bdnb.coord.lat,
                                    longitude: bdnb.coord.long + 0.0015
                                });
                                setAnchorEl(e);
                                setSelectedItem(bdnb)
                            }
                        }}
                        {...viewState}
                    >

                        <Source
                            type="geojson"
                            data={JSON.parse(irisGeoms[codeIris].geojson)}>
                            <Layer
                                type={'fill'}
                                paint={{
                                    'fill-color': getDpeColor(dpeIris[codeIris]),
                                    'fill-opacity': 0.1,
                                }}
                            />
                        </Source>
                        <Source
                            type="geojson"
                            data={generateGeoJsonFromBans()}
                        >
                            <Layer
                                id={'data'}
                                source={'bans'}
                                type={'circle'}
                                paint={{
                                    'circle-color': ['get', 'circleColor'],
                                    'circle-radius': ['get', 'circleRadius'],
                                    'circle-stroke-width': ['get', 'circleStrokeWidth'],
                                    'circle-stroke-color': ['get', 'circleStrokeColor'],
                                }}
                            />
                        </Source>
                        {hoverInfo && (
                            <Popup
                                longitude={hoverInfo.longitude}
                                latitude={hoverInfo.latitude}
                                offset={[0, -10]}
                                closeButton={false}

                            >
                                <Typography>{hoverInfo.adresse}</Typography>
                            </Popup>
                        )}

                        {false && listOfBans && Object.keys(listOfBans)
                            .filter((ban) => {
                                const bdnb = listOfBans[ban];

                                if (!bdnb?.coord?.lat || !bdnb?.coord?.long) {
                                    return false;
                                }
                                if (!filters.propCopro[bdnb.stats.prop]) {
                                    return false;
                                }
                                if (!filters.surf[bdnb.stats.surface]) {
                                    return false;
                                }
                                if (!filters.typeSelBat[bdnb.stats.batiment]) {
                                    return false;
                                }
                                if (!filters.date[bdnb.stats.periode]) {
                                    return false;
                                }
                                return true;
                            })
                            .map((ban, index) => {
                                const bdnb = listOfBans[ban];


                                let borderWidth = 2;
                                let containsDpesV2Style = bdnb.listOfDpesV2.length > 0 ? "solid" : "dotted";
                                let valDpe = "N";
                                if (dpev1 && bdnb.stats.dpeV1 !== "N" && filters.dpe[bdnb.stats.dpeV1]) {
                                    valDpe = bdnb.stats.dpeV1;
                                }
                                if (bdnb.stats.dpeV2 !== "N" && filters.dpe[bdnb.stats.dpeV2]) {
                                    valDpe = bdnb.stats.dpeV2;
                                }
                                let color = getDpeColor(valDpe);

                                let colorBorder = "#000";
                                if (bdnb.batiment_groupe_id === overBatimentGroupId) {
                                    colorBorder = "#ff0000";
                                    borderWidth = 5;
                                    if (bdnb.cle_interop_adr === bdnb.cle_interop_adr_principale_ban) {
                                        colorBorder = "#00ff00";
                                    }
                                }
                                if (selectedItem && selectedItem.cle_interop_adr === bdnb.cle_interop_adr) {

                                    colorBorder = "#ff0000";
                                    borderWidth = 5;
                                    if (bdnb.cle_interop_adr === bdnb.cle_interop_adr_principale_ban) {
                                        colorBorder = "#00ff00";
                                    }

                                }
                                let a = getAddresse2(bdnb.meta)

                                return (
                                    <Marker
                                        key={index}
                                        longitude={bdnb.coord.long}
                                        latitude={bdnb.coord.lat}
                                        anchor="bottom">
                                        <Tooltip title={a}>
                                            <IconButton
                                                onMouseOver={() => {
                                                    if (bdnb.batiment_groupe_id) {
                                                        setOverBatimentGroupId(bdnb.batiment_groupe_id)
                                                    }
                                                }}
                                                onMouseOut={() => {
                                                    setOverBatimentGroupId(undefined)
                                                }}
                                                size="small"
                                                sx={{
                                                    color: "#fff",
                                                    backgroundColor: color,
                                                    borderStyle: containsDpesV2Style,
                                                    borderColor: colorBorder,
                                                    borderRadius: 15,
                                                    borderWidth: borderWidth,
                                                    '&:hover': {
                                                        backgroundColor: color,
                                                        borderStyle: containsDpesV2Style,
                                                        borderColor: colorBorder,
                                                        borderRadius: 15,
                                                        borderWidth: 3,
                                                    },
                                                }}
                                                onClick={(e) => {
                                                    console.log("CLICK MARKER", bdnb);
                                                    setViewState({
                                                        ...viewState,
                                                        latitude: bdnb.coord.lat,
                                                        longitude: bdnb.coord.long + 0.0015
                                                    });
                                                    setAnchorEl(e.currentTarget);
                                                    setSelectedItem(bdnb)
                                                }}>

                                            </IconButton>
                                        </Tooltip>
                                    </Marker>
                                )
                            })}
                    </Map>

                    {selectedItem && bdnb_details && <Box sx={{
                        backgroundColor: "#ffffff",
                        width: widthOfRigth ? "50vw" : 45,
                        height: "100%",
                        zIndex: 99,
                        position: "absolute",
                        top: 0,
                        right: 0,
                        display: "flex",
                        transition: "width 300ms"
                    }}>
                        <Box>
                            {widthOfRigth && <IconButton onClick={() => {
                                setWidthOfRigth(false);
                                if (!anchorEl) {
                                    setSelectedItem(undefined);
                                }
                            }}>
                                <ArrowForwardIosIcon/>
                            </IconButton>}
                            {!widthOfRigth && <IconButton onClick={() => {
                                setWidthOfRigth(true);

                            }}>
                                <ArrowBackIosIcon/>
                            </IconButton>}


                        </Box>

                        {widthOfRigth &&
                            <RightAccordion
                                selectedItem={bdnb_details}
                            />}
                    </Box>}
                    {selectedItem && <Popover
                        open={open}
                        anchorEl={anchorEl}
                        anchorOrigin={{
                            vertical: 'bottom', horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'top', horizontal: 'center',
                        }}

                    >
                        {<KpiView
                            selectedItem={selectedItem}
                            showDetails={() => {
                                setWidthOfRigth(true);
                            }}
                            close={() => {
                                setAnchorEl(undefined);
                            }}
                        />}
                    </Popover>}

                </Box>
            </Box>)

    }
}


export let bdnb_millesime = "BDNB Millésime 2024-10.a";
